import { Button } from "@chakra-ui/button";
import { Box, Flex } from "@chakra-ui/layout";
import useGetContasBancarias from "features/contas_bancarias/hooks/useGetContasBancarias";
import colors from "core/resources/theme/colors";
import { useEffect, useState } from "react";
import { MdAccountBalance } from "react-icons/md";
import SelectBaseAntd from "../SelectBaseAntd";
import ModalContaBancaria from "components/Features/ContaBancaria/ModalContaBancaria";
import { SelectBaseAntdProps } from "./../SelectBaseAntd/index";

export interface SelectContaBancariaProps<T = any>
  extends SelectBaseAntdProps<T> {
  value: any;
  onChange: (v: any) => void;
  isInvalid?: boolean;
  markerDefault?: boolean;
  filteredIds?: string[];
  incluirInativas?: boolean;
}

function SelectContaBancaria({
  value,
  onChange,
  markerDefault,
  isInvalid,
  filteredIds = [],
  incluirInativas = true,
  ...rest
}: SelectContaBancariaProps) {
  const { isLoading, isFetching, data, refetch } = useGetContasBancarias({
    incluirInativas,
  });
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [search, setSearch] = useState<string>();

  useEffect(() => {
    if (!isOpenModal) {
      setSearch("");
    }
  }, [isOpenModal]);

  useEffect(() => {
    if (markerDefault && data?.items.length && !value) {
      const itemPadrao = data.items.find((item) => item.padrao);

      if (itemPadrao) {
        onChange(itemPadrao.id);
      }
    }
  }, [markerDefault, data, value, onChange]);

  return (
    <>
      <ModalContaBancaria
        isOpenModal={isOpenModal}
        onClose={() => setIsOpenModal(false)}
        onSuccess={async (id) => {
          onChange(id);

          refetch();

          setIsOpenModal(false);
        }}
      />

      <SelectBaseAntd
        isInvalid={isInvalid}
        loading={isLoading || isFetching}
        disabled={isLoading || isFetching}
        size="large"
        placeholder="Selecione..."
        value={value || undefined}
        onChange={onChange}
        allowClear={rest.mode === "multiple"}
        showArrow
        {...rest}
        showSearch
        searchValue={search}
        onSearch={(v) => {
          if (!isOpenModal) {
            setSearch(v);
          }
        }}
        optionFilterProp="extra"
        options={data?.items
          .filter((item) => !filteredIds.includes(item.id))
          .map((item) => ({
            value: item.id,
            label: (
              <Flex alignItems="center">
                <Flex mr="4px">
                  {item.imagemUrl ? (
                    <img
                      src={item.imagemUrl}
                      style={{
                        width: "28px",
                        height: "28px",
                        borderRadius: "4px",
                      }}
                      alt={`Logo ${item.nome}`}
                    />
                  ) : (
                    <Flex
                      w="28px"
                      h="28px"
                      rounded="4px"
                      bg="gray.100"
                      alignItems="center"
                      justifyContent="center"
                    >
                      <MdAccountBalance color={colors.black700} />
                    </Flex>
                  )}
                </Flex>
                <Flex flex={1} alignItems="center">
                  {item.nome} {item.padrao ? `(Principal)` : null}
                </Flex>
              </Flex>
            ),
            extra: `${item.bancoCodigo} - ${item.nome}`,
          }))}
        notFoundContent={
          !isLoading && !isFetching ? (
            <Box>
              Nada encontrado!!{" "}
              <Button
                leftIcon={<i className="mdi mdi-plus" />}
                size="xs"
                colorScheme="orange"
                onClick={() => setIsOpenModal(true)}
              >
                cadastrar novo
              </Button>
            </Box>
          ) : (
            <Box>Carregando...</Box>
          )
        }
      />
    </>
  );
}

export default SelectContaBancaria;
